import {Configuration} from '@shipwell/corrogo-sdk';
import {getAccessToken} from 'App/api/utils';

const basePath = process.env.SHIPWELL_CORROGO_API_BASE_PATH;

export const configuration = new Configuration({
  basePath,
  apiKey: getAccessToken
});
